// CUSTOMIZE SCRIPT

$(document).ready(function() {

    // HEADER HEIGHT FIX
    $(window).load(function() {
        setHeightHeaderCTN();
    });
    $(window).resize(function() {
        setHeightHeaderCTN();
    });

    function setHeightHeaderCTN() {
        var h_header = $('.headerGlobal').innerHeight();
        $('.headerContainer').height(h_header);

        var h_headermain = $('#header').height();
        $('#fixH').height(h_headermain);
    }


    // FEATURED-BLOG SYNC HEIGHT
    function featuredBlogSyncHeight() {
        var $itemBlog = $('.featured-blog .grid .grid__item .featured-blog__post');
        $itemBlog.removeAttr('style');
        var maxHeight = Math.max.apply(null, $itemBlog.map(function() {
            return $(this).height();
        }).get());
        $itemBlog.height(maxHeight);
    }


    // GRID ITEM SYNC HEIGHT
    function gridItemSyncHeight() {
        var $itemGrid = $('.grid .product-item .product-item__link-wrapper');
        $itemGrid.removeAttr('style');
        var maxHeight = Math.max.apply(null, $itemGrid.map(function() {
            return $(this).height();
        }).get());
        $itemGrid.height(maxHeight);
    }
    $(window).load(function() {
        featuredBlogSyncHeight();
        gridItemSyncHeight();
    });
    $(window).resize(function() {
        featuredBlogSyncHeight();
        gridItemSyncHeight();
    });
    $(document).ajaxComplete(function() {
        gridItemSyncHeight();
    });


    // GET PRODUCT NAME FOR CONTACT FORM
    if( $('.contact-form form#contact_form').length > 0 ) {
        var product_name = getUrlParameter('product');
        if( product_name ) {
            $('#ContactFormMessage').val(product_name);
        }
    }

    // GET PARAMATER URL
    function getUrlParameter(sParam) {
        var sPageURL = decodeURIComponent(window.location.search.substring(1)),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : sParameterName[1];
            }
        }
    };
    
    //RE-ORDER JAPAN PROVINCE
    if($('#multi-order-shipping-province-')){
        $('#multi-order-shipping-province-').html('<option value="Hokkaidō">北海道</option><option value="Aomori">青森県</option><option value="Iwate">岩手県</option><option value="Miyagi">宮城県</option><option value="Akita">秋田県</option><option value="Yamagata">山形県</option><option value="Fukushima">福島県</option><option value="Ibaraki">茨城県</option><option value="Tochigi">栃木県</option><option value="Gunma">群馬県</option><option value="Saitama">埼玉県</option><option value="Chiba">千葉県</option><option value="Tōkyō">東京都</option><option value="Kanagawa">神奈川県</option><option value="Niigata">新潟県</option><option value="Toyama">富山県</option><option value="Ishikawa">石川県</option><option value="Fukui">福井県</option><option value="Yamanashi">山梨県</option><option value="Nagano">長野県</option><option value="Gifu">岐阜県</option><option value="Shizuoka">静岡県</option><option value="Aichi">愛知県</option><option value="Mie">三重県</option><option value="Shiga">滋賀県</option><option value="Kyōto">京都府</option><option value="Ōsaka">大阪府</option><option value="Hyōgo">兵庫県</option><option value="Nara">奈良県</option><option value="Wakayama">和歌山県</option><option value="Tottori">鳥取県</option><option value="Shimane">島根県</option><option value="Okayama">岡山県</option><option value="Hiroshima">広島県</option><option value="Yamaguchi">山口県</option><option value="Tokushima">徳島県</option><option value="Kagawa">香川県</option><option value="Ehime">愛媛県</option><option value="Kōchi">高知県</option><option value="Fukuoka">福岡県</option><option value="Saga">佐賀県</option><option value="Nagasaki">長崎県</option><option value="Kumamoto">熊本県</option><option value="Ōita">大分県</option><option value="Miyazaki">宮崎県</option><option value="Kagoshima">鹿児島県</option><option value="Okinawa">沖縄県</option>');
    }
    
    $('.-required').each(function () {
        if ($(this).text() == '町名、番地') {
            $(this).text('番地');
        }
    });

    // HAMBEGER BUTTON MENU SP CLICK
    $('.hamburger').click(function() {
        if ($(this).hasClass("open")) {
            $(this).removeClass('open');
            $(this).addClass('close');
        } else {
            $(this).removeClass('close');
            $(this).addClass('open');
        }

        if ($(window).width() <= 768) {
            $('#header .mainMenu').stop().slideToggle();
            $('body').toggleClass('fixed');
        } else {

        }
    });

    // SCROLL ADD CLASS HEADER
    $(window).scroll(function(){
        if ($(this).scrollTop() > 50) {
            $('#header').addClass('showHeader');
        } else {
            $('#header').removeClass('showHeader');
        }
    });

    // ANCHOR CLICK LINK
    $('.anchor a, a.anchor').click(function() {
        if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $(this.hash + '_');
            if (target.length > 0) {
                let hheader = $('#header').height();
                $('html,body').animate({
                    scrollTop: target.offset().top - hheader
                }, 800);
                return false;
            }
        }
    });

    // SCROLL TOP
    $('.scrollTop').click(function() {
        $('html, body').animate({scrollTop : 0},800);
        return false;
    });

    // ANCHOR LOAD PAGE
    $(window).on('load', function(){
        let urlhash = window.location.hash;
        if( urlhash && urlhash.length > 0 ) {
            urlhash = urlhash + '_';
            let $elanchor = $(urlhash);
            if( $elanchor.length > 0 ) {
                let hheader = $('#header').height();
                let localel = $elanchor.offset().top - hheader;
                $('html, body').animate({scrollTop : localel}, 800);
            }
        }
    });
    
});